export function removeFalsyValues(obj:any){
  const falsyValues = ["", null, undefined]
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && falsyValues.includes(obj[key])) {
        delete obj[key];
      }
  }
  return obj;
}
